<template>
  <div class="spnod-admin__form--container container px-0 mx-0 w-100 h-100">
    <b-form @submit.stop.prevent="handleSubmit">
      <b-form-input
        v-model="$v.form.name.$model"
        name="name"
        :state="validateState('name')"
        type="text"
        placeholder="Name"
        size="sm"
        class="mb-2"
      ></b-form-input>
      <b-form-textarea
        v-model="$v.form.description.$model"
        name="description"
        :state="validateState('description')"
        type="text"
        rows="3"
        placeholder="Description"
        size="sm"
        class="mb-4"
      >
      </b-form-textarea>
      <b-form-row class="d-flex justify-content-between px-1">
        <b-form-group>
          <b-button class="bg-danger" size="sm" v-b-modal="modals.delete._id">
            <p v-if="!isDeleting">Delete</p>
            <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </b-button>
        </b-form-group>
        <b-form-group class="d-flex justify-content-end flex-grow">
          <b-button class="spnod-admin__form--button" @click="$router.go(-1)" size="sm">Cancel</b-button>
          <b-button class="spnod-admin__form--button" v-b-modal="modals.save._id" :disabled="isDisabled" size="sm">
            <p v-if="!isSaving">Save</p>
            <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </b-button>
        </b-form-group>
      </b-form-row>
    </b-form>

    <!--  Save Modal  -->
    <Modal
      :_id="modals.save._id"
      :message="modals.save.message"
      @success="handleSubmit" />

    <!--  Delete Modal  -->
    <Modal
      :_id="modals.delete._id"
      :message="modals.delete.message"
      @success="handleDelete" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { cloneDeep } from 'lodash'
import Modal from '../Notifications/Modal.vue'

export default {
  name: 'EditGroupForm',
  mixin: [validationMixin],
  components: { Modal },
  data() {
    return {
      form: {
        name: '',
        description: ''
      },
      isSaving: false,
      isDeleting: false,
      modals: {
        save: {
          _id: 'save',
          message: 'Are you sure you want to save?'
        },
        delete: {
          _id: 'delete',
          message: 'Are you sure you want to delete?'
        }
      }
    }
  },
  computed: {
    ...mapGetters(['group', 'activeGroup']),
    isDisabled() {
      const anyBlanks = Object.entries(this.form).some(obj => obj[1] === '')
      return anyBlanks || this.$v.form.$anyError
    }
  },
  methods: {
    ...mapActions(['updateGroup', 'deleteGroup']),
    handleSubmit: async function () {
      this.isSaving = true
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.isSaving = false
        return
      }
      await this.updateGroup(this.form)
      this.$router.push('/group')
    },
    handleDelete: async function() {
      this.isDeleting = true
      await this.deleteGroup()
      this.$router.push('/group')
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    }
  },
  mounted: async function () {
    this.form = cloneDeep(this.group)
  },
  validations: {
    form: {
      name: { required },
      description: { required }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Forms/EditGroupForm.vue?3128bdcc